"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchNip05Pubkey = exports.bech32ToText = exports.bech32ToHex = exports.getPublicKey = exports.sha256 = exports.appendDedupe = exports.dedupe = exports.distance = exports.equalProp = exports.countMembers = exports.deepEqual = exports.deepClone = exports.unixNowMs = exports.unixNow = exports.sanitizeRelayUrl = exports.hexToBech32 = exports.unwrap = void 0;
const utils = __importStar(require("@noble/curves/abstract/utils"));
const secp = __importStar(require("@noble/curves/secp256k1"));
const sha256_1 = require("@noble/hashes/sha256");
const base_1 = require("@scure/base");
function unwrap(v) {
    if (v === undefined || v === null) {
        throw new Error("missing value");
    }
    return v;
}
exports.unwrap = unwrap;
/**
 * Convert hex to bech32
 */
function hexToBech32(hrp, hex) {
    if (typeof hex !== "string" || hex.length === 0 || hex.length % 2 !== 0) {
        return "";
    }
    try {
        const buf = utils.hexToBytes(hex);
        return base_1.bech32.encode(hrp, base_1.bech32.toWords(buf));
    }
    catch (e) {
        console.warn("Invalid hex", hex, e);
        return "";
    }
}
exports.hexToBech32 = hexToBech32;
function sanitizeRelayUrl(url) {
    try {
        return new URL(url).toString();
    }
    catch {
        // ignore
    }
}
exports.sanitizeRelayUrl = sanitizeRelayUrl;
function unixNow() {
    return Math.floor(unixNowMs() / 1000);
}
exports.unixNow = unixNow;
function unixNowMs() {
    return new Date().getTime();
}
exports.unixNowMs = unixNowMs;
function deepClone(obj) {
    if ("structuredClone" in window) {
        return structuredClone(obj);
    }
    else {
        return JSON.parse(JSON.stringify(obj));
    }
}
exports.deepClone = deepClone;
function deepEqual(x, y) {
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === "object" && tx === ty
        ? ok(x).length === ok(y).length && ok(x).every(key => deepEqual(x[key], y[key]))
        : x === y;
}
exports.deepEqual = deepEqual;
function countMembers(a) {
    let ret = 0;
    for (const [k, v] of Object.entries(a)) {
        if (Array.isArray(v)) {
            ret += v.length;
        }
    }
    return ret;
}
exports.countMembers = countMembers;
function equalProp(a, b) {
    if ((a !== undefined && b === undefined) || (a === undefined && b !== undefined)) {
        return false;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }
        if (!a.every(v => b.includes(v))) {
            return false;
        }
    }
    return a === b;
}
exports.equalProp = equalProp;
/**
 * Compute the "distance" between two objects by comparing their difference in properties
 * Missing/Added keys result in +10 distance
 * This is not recursive
 */
function distance(a, b) {
    const keys1 = Object.keys(a);
    const keys2 = Object.keys(b);
    const maxKeys = keys1.length > keys2.length ? keys1 : keys2;
    let distance = 0;
    for (const key of maxKeys) {
        if (key in a && key in b) {
            if (Array.isArray(a[key]) && Array.isArray(b[key])) {
                const aa = a[key];
                const bb = b[key];
                if (aa.length === bb.length) {
                    if (aa.some(v => !bb.includes(v))) {
                        distance++;
                    }
                }
                else {
                    distance++;
                }
            }
            else if (a[key] !== b[key]) {
                distance++;
            }
        }
        else {
            distance += 10;
        }
    }
    return distance;
}
exports.distance = distance;
function dedupe(v) {
    return [...new Set(v)];
}
exports.dedupe = dedupe;
function appendDedupe(a, b) {
    return dedupe([...(a ?? []), ...(b ?? [])]);
}
exports.appendDedupe = appendDedupe;
const sha256 = (str) => {
    return utils.bytesToHex((0, sha256_1.sha256)(str));
};
exports.sha256 = sha256;
function getPublicKey(privKey) {
    return utils.bytesToHex(secp.schnorr.getPublicKey(privKey));
}
exports.getPublicKey = getPublicKey;
function bech32ToHex(str) {
    try {
        const nKey = base_1.bech32.decode(str, 1000);
        const buff = base_1.bech32.fromWords(nKey.words);
        return utils.bytesToHex(Uint8Array.from(buff));
    }
    catch (e) {
        return str;
    }
}
exports.bech32ToHex = bech32ToHex;
/**
 * Decode bech32 to string UTF-8
 * @param str bech32 encoded string
 * @returns
 */
function bech32ToText(str) {
    try {
        const decoded = base_1.bech32.decode(str, 1000);
        const buf = base_1.bech32.fromWords(decoded.words);
        return new TextDecoder().decode(Uint8Array.from(buf));
    }
    catch {
        return "";
    }
}
exports.bech32ToText = bech32ToText;
async function fetchNip05Pubkey(name, domain, timeout = 2000) {
    if (!name || !domain) {
        return undefined;
    }
    try {
        const res = await fetch(`https://${domain}/.well-known/nostr.json?name=${encodeURIComponent(name)}`, {
            signal: AbortSignal.timeout(timeout),
        });
        const data = await res.json();
        const match = Object.keys(data.names).find(n => {
            return n.toLowerCase() === name.toLowerCase();
        });
        return match ? data.names[match] : undefined;
    }
    catch {
        // ignored
    }
    return undefined;
}
exports.fetchNip05Pubkey = fetchNip05Pubkey;
//# sourceMappingURL=data:application/json;base64,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